"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchNip05Pubkey = exports.bech32ToText = exports.bech32ToHex = exports.getPublicKey = exports.sha256 = exports.appendDedupe = exports.dedupe = exports.distance = exports.equalProp = exports.countMembers = exports.deepEqual = exports.deepClone = exports.unixNowMs = exports.unixNow = exports.sanitizeRelayUrl = exports.hexToBech32 = exports.unwrap = void 0;
const utils = __importStar(require("@noble/curves/abstract/utils"));
const secp = __importStar(require("@noble/curves/secp256k1"));
const sha256_1 = require("@noble/hashes/sha256");
const base_1 = require("@scure/base");
function unwrap(v) {
    if (v === undefined || v === null) {
        throw new Error("missing value");
    }
    return v;
}
exports.unwrap = unwrap;
/**
 * Convert hex to bech32
 */
function hexToBech32(hrp, hex) {
    if (typeof hex !== "string" || hex.length === 0 || hex.length % 2 !== 0) {
        return "";
    }
    try {
        const buf = utils.hexToBytes(hex);
        return base_1.bech32.encode(hrp, base_1.bech32.toWords(buf));
    }
    catch (e) {
        console.warn("Invalid hex", hex, e);
        return "";
    }
}
exports.hexToBech32 = hexToBech32;
function sanitizeRelayUrl(url) {
    try {
        return new URL(url).toString();
    }
    catch {
        // ignore
    }
}
exports.sanitizeRelayUrl = sanitizeRelayUrl;
function unixNow() {
    return Math.floor(unixNowMs() / 1000);
}
exports.unixNow = unixNow;
function unixNowMs() {
    return new Date().getTime();
}
exports.unixNowMs = unixNowMs;
function deepClone(obj) {
    if ("structuredClone" in window) {
        return structuredClone(obj);
    }
    else {
        return JSON.parse(JSON.stringify(obj));
    }
}
exports.deepClone = deepClone;
function deepEqual(x, y) {
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === "object" && tx === ty
        ? ok(x).length === ok(y).length && ok(x).every(key => deepEqual(x[key], y[key]))
        : x === y;
}
exports.deepEqual = deepEqual;
function countMembers(a) {
    let ret = 0;
    for (const [k, v] of Object.entries(a)) {
        if (Array.isArray(v)) {
            ret += v.length;
        }
    }
    return ret;
}
exports.countMembers = countMembers;
function equalProp(a, b) {
    if ((a !== undefined && b === undefined) || (a === undefined && b !== undefined)) {
        return false;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }
        if (!a.every(v => b.includes(v))) {
            return false;
        }
    }
    return a === b;
}
exports.equalProp = equalProp;
/**
 * Compute the "distance" between two objects by comparing their difference in properties
 * Missing/Added keys result in +10 distance
 * This is not recursive
 */
function distance(a, b) {
    const keys1 = Object.keys(a);
    const keys2 = Object.keys(b);
    const maxKeys = keys1.length > keys2.length ? keys1 : keys2;
    let distance = 0;
    for (const key of maxKeys) {
        if (key in a && key in b) {
            if (Array.isArray(a[key]) && Array.isArray(b[key])) {
                const aa = a[key];
                const bb = b[key];
                if (aa.length === bb.length) {
                    if (aa.some(v => !bb.includes(v))) {
                        distance++;
                    }
                }
                else {
                    distance++;
                }
            }
            else if (a[key] !== b[key]) {
                distance++;
            }
        }
        else {
            distance += 10;
        }
    }
    return distance;
}
exports.distance = distance;
function dedupe(v) {
    return [...new Set(v)];
}
exports.dedupe = dedupe;
function appendDedupe(a, b) {
    return dedupe([...(a ?? []), ...(b ?? [])]);
}
exports.appendDedupe = appendDedupe;
const sha256 = (str) => {
    return utils.bytesToHex((0, sha256_1.sha256)(str));
};
exports.sha256 = sha256;
function getPublicKey(privKey) {
    return utils.bytesToHex(secp.schnorr.getPublicKey(privKey));
}
exports.getPublicKey = getPublicKey;
function bech32ToHex(str) {
    try {
        const nKey = base_1.bech32.decode(str, 1000);
        const buff = base_1.bech32.fromWords(nKey.words);
        return utils.bytesToHex(Uint8Array.from(buff));
    }
    catch (e) {
        return str;
    }
}
exports.bech32ToHex = bech32ToHex;
/**
 * Decode bech32 to string UTF-8
 * @param str bech32 encoded string
 * @returns
 */
function bech32ToText(str) {
    try {
        const decoded = base_1.bech32.decode(str, 1000);
        const buf = base_1.bech32.fromWords(decoded.words);
        return new TextDecoder().decode(Uint8Array.from(buf));
    }
    catch {
        return "";
    }
}
exports.bech32ToText = bech32ToText;
async function fetchNip05Pubkey(name, domain, timeout = 2000) {
    if (!name || !domain) {
        return undefined;
    }
    try {
        const res = await fetch(`https://${domain}/.well-known/nostr.json?name=${encodeURIComponent(name)}`, {
            signal: AbortSignal.timeout(timeout),
        });
        const data = await res.json();
        const match = Object.keys(data.names).find(n => {
            return n.toLowerCase() === name.toLowerCase();
        });
        return match ? data.names[match] : undefined;
    }
    catch {
        // ignored
    }
    return undefined;
}
exports.fetchNip05Pubkey = fetchNip05Pubkey;
//# sourceMappingURL=data:application/json;base64,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